import {MeasurementUnit} from "../measurement-unit.model";

export class GoalCreateDto {

    constructor(
        public name: string,
        public description: string,
        public startDate: Date,
        public finishDate: Date,
        public orderNumber: number,
        public tagIds: string[],
        public currentProgressValue: number,
        public finishProgressValue: number,
        public measurementUnit: MeasurementUnit | null
    ) {
    }
}
